angular.module("app").controller("EmptyPageController", [
    function () {
    }
]);